import {
  ApplicationConfig,
  LOCALE_ID} from '@angular/core';
import {
  APP_INITIALIZER,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection, isDevMode,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { routes } from './app.routes';
import {
  httpAuthRefreshInterceptor,
  httpErrorInterceptor,
  httpLoadingInterceptor,
  httpRequestIdInterceptor,
} from '@core/interceptors';
import { AuthService } from '@core/services';
import { provideServiceWorker } from '@angular/service-worker';

function restoreSessionFactory(authService: AuthService) {
  return () => authService.restoreSession();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'es-CO' },
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([
        httpRequestIdInterceptor,
        httpLoadingInterceptor,
        httpErrorInterceptor,
        httpAuthRefreshInterceptor,
      ]),
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: restoreSessionFactory,
      deps: [AuthService],
      multi: true,
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
